export default __webpack_public_path__ + "static/107996-019c71fae5284a7484a52d726d56fec1.jpg";